import IndexPage from "@/pages";
import {getHomePageProps} from "@/lib/getHomePageProps";
import {useRouter} from "next/router";
import {useEffect} from "react";
import {useLocalStorage} from "@/util/hooks/useLocalStorage";

export const getServerSideProps = getHomePageProps;

function ReferralPage(props) {
    const router = useRouter();
    const referral = router.query.referral;
    const [, setStoredReferral] = useLocalStorage(`r`, null);

    useEffect(() => {
        if (referral) {
            setStoredReferral({
                key: referral
            });
        }
    }, [referral, setStoredReferral]);

    return <IndexPage {...props} />
}

export default ReferralPage;

